import Colors from "./Colors";

export class Office {
    constructor(obj) {
        this.BrandName = obj.BrandName;
        this.ID = obj.ID;
        this.PhoneNumber = obj.PhoneNumber;
        this.Email = obj.Email;
        this.PostCode = obj.PostCode;
        this.Address = obj.Address;
        this.AreaName = obj.AreaName;
        this.Longtitude = obj.Longtitude;
        this.Latitude = obj.Latitude;
        this.Ibans = obj.Ibans;
        this.Colors = new Colors(obj.Colors);
        this.Paypal_Client_ID = obj.Paypal_Client_ID;
    }
}
